
const Contact = () => {
  return (
    <div>
      <h1 style={{display:'flex', flexDirection:"column", justifyContent:'center', alignItems:'center'}}>Contactanos</h1>
      <p style={{ textAlign: 'center' }}>Somos un grupo de beachtennis ubicados en la ciudad de medellin, para mas información no dudes en escribirnos a nuestro whatsapp Luis:+57 316 3606304 Ozzie: +57 313 6416064</p>
    </div>
  );
}
export default Contact;
